import { FETCH_CONTENTFUL, FETCH_CONTENTFUL_FAIL } from './types';
import ContentfulHelper from '../helpers/contentfulhelper';

/**
 * Fetch contentful data via contentful helper
 *
 */
export function FetchContentful(){
  return dispatch => {
    Promise.all([
      ContentfulHelper.fetchEntriesType('categoryWhere', ['fields.name', 'fields.order']),
      ContentfulHelper.fetchEntriesType('category', ['fields.name', 'fields.order']),
      ContentfulHelper.fetchEntriesType('product', ['fields.name', 'fields.nameShort', 'fields.category','fields.continent', 'fields.countries',
      'fields.duration', 'fields.highlightImages', 'fields.popularity', 'fields.tourId', 'fields.webUrl','fields.map', 'fields.people',  'fields.sort', 'fields.categoryWhere', 'fields.startCity', 'fields.endCity'])
    ]).then(data => {
      dispatch({type:FETCH_CONTENTFUL, payload:data});
    })
    .catch(err => {
      dispatch({type:FETCH_CONTENTFUL_FAIL});
      console.error(err);
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/contentful.js